module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/Card-d687e56ca81e26226c9199afe621da7a.mp4";